import API from './jsonapi-constants'

export const CONSTANTS = {
  ATTRIBUTE: {
    CONTENT: 'text.content',
    DOMAIN: 'text.domain',
    ID: 'text.id',
    LABEL: 'text.label',
    LANGUAGEID: 'text.languageid',
    STATUS: 'text.status',
    TYPE: 'text.type',
  },
  TYPE: {
    NAME: 'name',
    DEALERUSP_REGEX: /^ProductDealerUSP[1-3]$/,
  },
}

export const PATHS = {
  CONTENT: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CONTENT],
  DOMAIN: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DOMAIN],
  ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ID],
  LABEL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LABEL],
  LANGUAGEID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LANGUAGEID],
  STATUS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATUS],
  TYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TYPE],
}

export default {
  ...CONSTANTS,
  PATHS,
}
